/** @format */

import { createReducer, on } from '@ngrx/store';
import {
	getProductBundleDataAction,
	getProductDataAction,
	setBopisInventory,
	setCustomProductData,
	setEcommInventory,
	setEDDInfo,
	setFBTProducts,
	setLoadingProductImages,
	setPrimaryCategory,
	setProductHasEmptyPriceAndHasPrice,
	setPromotionData,
	setResolvedSku,
	setSDDInfo,
	setSelectedPersonalizationOptions,
	setShippingInfo,
	setStyliticsWidgetShown
} from './product-selection.actions';

import { ProductSelectionCoreState } from '@pdp/data-access/interfaces';

// 02 Define the initial state
export const initialProductSelectionState: ProductSelectionCoreState = {
	productStyle: {},
	bundleData: {},
	bundleProductsData: [],
	productSkus: [],
	resolvedSku: null,
	resolvedSkuSDDInventory: null,
	ecommInventory: null,
	bopisInventory: null,
	primaryCategory: null,
	hasEmptyPriceAndHasPrice: false,
	shippingInfo: {},
	promotionData: null,
	eddInfo: null,
	customProductData: null,
	loadingProductImages: false,
	selectedPersonalizationOptions: {},
	FBTProducts: [],
	styliticsWidgetShown: false,
	productHasColorWithStylitics: false
};

export const productSelectionReducers = createReducer(
	// Supply the initial state
	initialProductSelectionState,
	on(getProductDataAction, (state, { productStyle, productSkus }) => ({
		...state,
		productStyle,
		productSkus
	})),
	on(getProductBundleDataAction, (state, { bundleData, bundleProductsData }) => ({
		...state,
		bundleData,
		bundleProductsData
	})),
	on(setResolvedSku, (state, { resolvedSku }) => ({
		...state,
		resolvedSku,
		eddInfo: undefined
	})),
	on(setSDDInfo, (state, { sdd }) => ({
		...state,
		resolvedSkuSDDInventory: sdd
	})),
	on(setEDDInfo, (state, { eddInfo }) => ({
		...state,
		eddInfo
	})),
	on(setEcommInventory, (state, { ecommInventory }) => ({
		...state,
		ecommInventory
	})),
	on(setBopisInventory, (state, { bopisInventory }) => ({
		...state,
		bopisInventory
	})),
	on(setPrimaryCategory, (state, { primaryCategory }) => ({
		...state,
		primaryCategory
	})),
	on(setProductHasEmptyPriceAndHasPrice, (state, { hasEmptyPriceAndHasPrice }) => ({
		...state,
		hasEmptyPriceAndHasPrice
	})),
	on(setShippingInfo, (state, { shippingInfo }) => ({
		...state,
		shippingInfo
	})),
	on(setPromotionData, (state, { promotionData }) => ({
		...state,
		promotionData
	})),
	on(setCustomProductData, (state, { customProductData }) => ({
		...state,
		customProductData
	})),
	on(setLoadingProductImages, (state, { loadingProductImages }) => ({
		...state,
		loadingProductImages
	})),
	on(setSelectedPersonalizationOptions, (state, { selectedPersonalizationOptions }) => ({
		...state,
		selectedPersonalizationOptions
	})),
	on(setFBTProducts, (state, { FBTProducts }) => ({
		...state,
		FBTProducts
	})),
	on(setStyliticsWidgetShown, (state, { styliticsWidgetShown }) => ({
		...state,
		styliticsWidgetShown,
		productHasColorWithStylitics: state.productHasColorWithStylitics || styliticsWidgetShown
	}))
);
